import React from 'react';
import styled from 'styled-components';
import { ShowsHero, ShowsSection } from '../components/shows';
import { FloatingPattern } from '../components/common';

const PageContainer = styled.div`
    position: relative;
    padding-top: 70px;
    overflow-x: hidden;
`;

// Show data
const upcomingShows = [
    {
        date: 'April 30th',
        venue: 'The Pyramid Scheme',
        location: 'Grand Rapids, MI',
        ticketsLink: 'https://pyramidschemebar.com/',
    },
];

export const ShowsPage: React.FC = () => {
    return (
        <PageContainer>
            <FloatingPattern />
            <ShowsHero />
            <ShowsSection shows={upcomingShows} />
        </PageContainer>
    );
};
